import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Field, reduxForm } from 'redux-form';
import { withRouter } from 'react-router';

import { ServedItemAccessFieldEnum as Fields } from 'Common/FieldEnum';
import { ASSIGN_SERVED_ITEMS_TO_SITE_FORM_NAME } from 'Common/FormEnum';
import { SelectServedItemsTable } from './SelectServedItemsTable';

class AssignServedItemsToSite extends Component {
  static props = {
    serveditems: PropTypes.array.isRequired,
    loading: PropTypes.bool.isRequired,
  };

  render() {
    return (
      <React.Fragment>
        <Field
          name={Fields.ItemIds}
          component={SelectServedItemsTable}
          loading={this.props.loading}
          servedItems={this.props.servedItems}
        />
      </React.Fragment>
    );
  }
}

export const AssignServedItemsToSiteForm = reduxForm({
  form: ASSIGN_SERVED_ITEMS_TO_SITE_FORM_NAME,
  enableReinitialize: true,
})(withRouter(AssignServedItemsToSite));



// WEBPACK FOOTER //
// ./src/pages/serveditemaccesssetup/components/AssignServedItemsToSiteForm.js